// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root__UKfa8","menu":"Dropdown_menu__1BGKD"};